// @flow
import * as React from 'react';

import styles from './ProductDetailsHeader.module.scss';;


type Props = {
  children: React.Node,
}

const ProductDetailsHeader = ({ children }: Props) => (
  <h2 className={styles.root}>
    {children}
  </h2>
);

export default ProductDetailsHeader;
